const MainPageConsentsInfo = () => {
  return null;
};

export default MainPageConsentsInfo;
